const pjson = require('../../package.json');
export const version_number = pjson.version;
